import { WORKFLOW_RUN_ASK_TURN_ASK_ID_PREFIX } from '@digital-twins/shared-types'

/**
 * Declared in shared-types (`workflow-run-ask-ids.ts`). Distinct from
 * `workflow-run-complete:<token>` so findMessageByAskId keeps the ask turn
 * and the completion announcement apart.
 */
export { WORKFLOW_RUN_ASK_TURN_ASK_ID_PREFIX }

export function workflowRunAskTurnAskId(runToken: string): string {
  return `${WORKFLOW_RUN_ASK_TURN_ASK_ID_PREFIX}${runToken}`
}

export function isWorkflowRunAskTurnAskId(
  askId: string | null | undefined,
): boolean {
  return Boolean(askId && askId.startsWith(WORKFLOW_RUN_ASK_TURN_ASK_ID_PREFIX))
}
